import type { MouseEvent } from 'react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { PromoMaterialDto, PromoMaterialKey } from 'api/ClientArea/PromoMaterialDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const PromoMaterialActiveCell = (props: GridCellProps) => {
  const enabled = props.dataItem.enabled || false

  return (
    <td width={80} style={{ textAlign: 'center' }}>
      <Badge variant={enabled ? 'outline-info' : 'neutral'}>{enabled ? 'Yes' : 'No'}</Badge>{' '}
    </td>
  )
}

const createPromoMaterialNameCell = (onEdit: (data: PromoMaterialDto) => void) => {
  return (props: GridCellProps) => {
    const name = props.dataItem.name

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onEdit(props.dataItem)
    }

    return (
      <td className='table-columns__content' style={{ textAlign: 'left' }}>
        <Button
          type='button'
          variant='link'
          onMouseDown={(event) => event.stopPropagation()}
          onClick={handleClick}
        >
          {name}
        </Button>
      </td>
    )
  }
}

export const promoMaterialColumn = (onEdit: (data: PromoMaterialDto) => void): GridColumn[] => [
  {
    title: 'Name',
    field: PromoMaterialKey.name,
    cell: createPromoMaterialNameCell(onEdit),
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Language',
    field: PromoMaterialKey.language,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Size',
    field: PromoMaterialKey.size,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Type',
    field: PromoMaterialKey.type,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 120,
  },
  {
    title: 'Active',
    field: PromoMaterialKey.active,
    cell: PromoMaterialActiveCell,
    show: true,
    className: 'table-columns__content',
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
]
